import { Box, Typography } from "@mui/material";

type MultiLineCellProps = {
  lines: (string | null | undefined)[];
};

export const MultiLineCell: React.FC<MultiLineCellProps> = ({ lines }) => {
  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
      }}
    >
      {lines?.map((line, index) =>
        line ? (
          <Typography key={index} variant="body2" noWrap>
            {line}
          </Typography>
        ) : null
      )}
    </Box>
  );
};
